import { PDFDocument, PDFFont, StandardFonts } from "pdf-lib";
// @ts-ignore
import fontkit from "@pdf-lib/fontkit";

export interface PdfTheme {
  helvetica: PDFFont;
  customFont: PDFFont;
  customFontBold: PDFFont;
}

/**
 * Loads standard and custom fonts for PDF generation.
 */
export async function loadPdfTheme(pdfDoc: PDFDocument): Promise<PdfTheme> {
  pdfDoc.registerFontkit(fontkit);
  const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica);
  let customFont = helvetica;
  let customFontBold = helvetica;

  const loadFont = async (url: string): Promise<PDFFont | null> => {
    try {
      const fontBytes = await fetch(url).then((res) => {
        if (!res.ok) throw new Error(`Font fetch failed: ${res.status}`);
        return res.arrayBuffer();
      });
      if (fontBytes && fontBytes.byteLength > 0) {
        return await pdfDoc.embedFont(fontBytes);
      }
    } catch (e) {
      console.warn(`Failed to load ${url}:`, e);
    }
    return null;
  };

  const lightFont = await loadFont("/fonts/SpaceGrotesk-Light.otf");
  const mediumFont = await loadFont("/fonts/SpaceGrotesk-Medium.otf");

  if (lightFont) {
    customFont = lightFont;
  }
  if (mediumFont) {
    customFontBold = mediumFont;
  }

  // Fallback logic
  if (customFont === helvetica && customFontBold !== helvetica) {
    customFont = customFontBold;
  } else if (customFontBold === helvetica && customFont !== helvetica) {
    customFontBold = customFont;
  }

  return { helvetica, customFont, customFontBold };
}
